import React from "react";

const LocationMap = () => {
  return (
    <div className="mx-auto mt-8 max-w-screen-2xl rounded-3xl bg-white p-4 shadow-md sm:p-8">
      <h2 className="mb-4 text-xl font-bold">Location/Map</h2>

      {/* Replace this with your actual Google Maps embed or image */}
      <img
        src="https://indianexpress.com/wp-content/uploads/2017/05/google-maps-759.jpg"
        alt="Hotel Location Map API key Required"
        className="h-[600px] w-full rounded-xl object-cover"
      />
    </div>
  );
};

export default LocationMap;
